import './TagFilter.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Select } from 'antd';
import { SonarTagDisplay } from '@ui/tags/SonarTag';
import { sortBy } from 'lodash';
import { stringContainsSubstringCaseInsensitive } from '@sonar-software/sonar-ts-lib';
import React, { useCallback, useMemo } from 'react';
import { useTags } from '@hooks';
export const TagFilter = ({ disabled, onChange, value }) => {
    const tags = useTags(false);
    const options = useMemo(() => sortBy(tags.map((tag) => ({
        label: React.createElement(SonarTagDisplay, { noBorder: true, tagId: tag.id }),
        optionLabel: tag.name,
        value: tag.id
    })), (tag) => tag.label), [tags]);
    const handleFilter = (input, option) => stringContainsSubstringCaseInsensitive(option === null || option === void 0 ? void 0 : option.optionLabel, input);
    const onTagSelect = useCallback((tagIds) => {
        onChange({
            tagIds: tagIds
        });
    }, [onChange]);
    return (React.createElement("div", { className: 'tag-filter-container' },
        React.createElement(Select, { allowClear: true, className: 'tag-filter', disabled: disabled, filterOption: handleFilter, mode: 'multiple', onChange: onTagSelect, optionFilterProp: 'label', optionLabelProp: 'label', options: options, placeholder: COPY_SPECIFIC.TAG, value: value })));
};
